import {  createContext } from 'react';

const InvoiceContext = createContext();

export default InvoiceContext;